import React from "react";
import { Link } from "react-router-dom";
import { Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { BreadcrumbsBar } from "../../../common/components/BreadcrumbsBar";

interface SupplierDetailTopPanelProps {
    supplierName: string;
    supplierId: number;
}

export const SupplierDetailTopPanel: React.FC<SupplierDetailTopPanelProps> = ({
    supplierName,
    supplierId,
}) => {
    const breadcrumbs = [
        {
            name: "Buyer briefs",
            path: "/briefs",
        },
        {
            name: `${supplierName}`,
            path: `/supplier/${supplierId}`,
        },
    ];

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <BreadcrumbsBar breadcrumbs={breadcrumbs} />
            </div>
            <Link to="/briefs">
                <Space>
                    <ArrowLeftOutlined />
                    Back to Buyer briefs
                </Space>
            </Link>
        </div>
    );
};
